<template>
  <div class="article-detail">
    <div v-if="!hideBreadcrumb" class="breadcrumb">
      <img :src="pointImg" alt="" class="breadcrumb-icon">
      <span>当前位置：
        <span class="breadcrumb-link" @click="$emit('go-home')">首页</span>
        <template v-if="breadcrumbSegments.length">
          <span v-for="(seg, i) in breadcrumbSegments" :key="i">
            <span> / </span>
            <span v-if="i < breadcrumbSegments.length - 1" class="breadcrumb-link" @click="$emit('breadcrumb-click', seg)">{{ seg }}</span>
            <span v-else>{{ seg }}</span>
          </span>
        </template>
        <template v-else>
          <span> / {{ section }}</span>
        </template>
      </span>
    </div>
    <div class="detail-title">{{ article.title }}</div>
    <div v-if="!hideDate" class="detail-date">{{ article.date }}</div>
    <div class="detail-content">
      <div v-if="article.content" v-html="article.content"></div>
      <p v-else>{{ article.desc || article.title }}</p>
    </div>
    <div v-if="nextTitle" class="next-article" @click="$emit('next-article')">
      下一篇：{{ nextTitle }}
    </div>
    <div v-else class="next-article no-more">已是最后一篇</div>
  </div>
</template>

<script>
import pointImg from '../assets/imgs/point.png'

export default {
  name: 'ArticleDetail',
  props: {
    article: { type: Object, required: true },
    section: { type: String, default: '' },
    breadcrumb: { type: Array, default: null },
    nextTitle: { type: String, default: '' },
    hideBreadcrumb: { type: Boolean, default: false },
    hideDate: { type: Boolean, default: false },
  },
  emits: ['go-home', 'next-article', 'breadcrumb-click'],
  data() {
    return { pointImg }
  },
  computed: {
    breadcrumbSegments() {
      if (this.breadcrumb && this.breadcrumb.length) {
        return this.breadcrumb
      }
      return []
    },
  },
}
</script>

<style scoped lang="less">
.article-detail{
  padding: 0.3rem;
  padding-bottom: 0.4rem;
  min-height: 10rem;
  .breadcrumb{
    padding-top: 0.1rem;
    padding-left: 0.1rem;
    padding-right: 0.1rem;
    font-size: 0.24rem;
    color: #666;
    display: flex;
    align-items: center;
    margin-bottom: 0.3rem;
    .breadcrumb-icon{
      width: 0.2rem;
      margin-right: 0.1rem;
    }
    .breadcrumb-link{
      cursor: pointer;
      &:hover{ color: #369BF8; }
    }
  }
  .detail-title{
    font-size: 0.32rem;
    font-weight: bold;
    color: #000;
    text-align: center;
    margin-bottom: 0.15rem;
  }
  .detail-date{
    font-size: 0.18rem;
    color: #999;
    text-align: center;
    margin-bottom: 0.3rem;
  }
  .detail-content{
    font-size: 0.2rem;
    color: #4F4E4E;
    line-height: 0.45rem;
    p{
      text-indent: 2em;
      margin-bottom: 0.15rem;
    }
    img{ max-width: 100%; }
  }
  .next-article{
    margin-top: 0.4rem;
    font-size: 0.2rem;
    color: #369BF8;
    cursor: pointer;
    text-align: left;
    &:hover{ color: #1a6bb5; }
  }
}
</style>
